<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Rijbewijs CE halen?</h1>
      <p>
        Wil je in de toekomst graag met een aanhanger achter de vrachtwagen
        rijden en ben je op zoek naar een rijschool voor het behalen van het
        rijbewijs CE? Via Rijscholenvergelijker.nl kom je er achter bij welke
        rijschool in jouw omgeving je het beste af bent. Waar ligt het uurtarief
        het laagst? Hoe zit het met de slagingspercentages? Hoe zijn de lessen
        opgebouwd? Hier kom je gratis én vrijblijvend in contact met
        verschillende regionale rijscholen, die we op basis van je postcode
        selecteren. Zij nemen binnen één dag contact met je op, waarna je zelf
        kunt bepalen waar je uiteindelijk het goedkoopst je rijbewijs CE kunt
        behalen. Maak gebruik van die mogelijkheden en laat vandaag nog je
        gegevens achter op de website!
      </p>

      <h2>Rijbewijs CE</h2>
      <p>
        Om in aanmerking te komen voor het rijbewijs CE, dien je logischerwijs
        al in het bezit te zijn van rijbewijs C; de toevoeging E zorgt er voor
        dat je een vrachtwagen mét aanhanger mag besturen. Tijdens de rijlessen
        leer je onder andere de aanhangwagen aan en af te koppelen, het voertuig
        te beheersen en uiteraard deel te nemen aan het verkeer. Wil je weten
        welke opleiding in jouw regio het beste is afgestemd op je werkzaamheden
        als chauffeur? Je komt erachter door informatie aan te vragen op
        Rijscholenvergelijker.nl.
      </p>

      <h2>Alle rijbewijzen</h2>
      <p>
        Op de website kun je niet alleen terecht voor de beste rijscholen die je
        helpen aan het rijbewijs CE; ook voor bijvoorbeeld het
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-b">
          rijbewijs B </nuxt-link
        >, het
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-a">
          motorrijbewijs
        </nuxt-link>
        en het
        <nuxt-link to="/informatie-over-rijscholen/rijbewijs-c">
          rijbewijs C
        </nuxt-link>
        ben je hier aan het juiste adres. Laat dus snel je gegevens achter en
        laat de <nuxt-link to="/"> rijscholen </nuxt-link> in jouw omgeving
        binnen 24 uur contact opnemen!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Rijbewijs CE halen? Gratis offertes op Rijscholenvergelijker.nl!',
      headDescription:
        'Wil je graag je rijbewijs CE gaan halen? Kies voor de beste rijschool in jouw omgeving en vergelijk gratis offertes op Rijscholenvergelijker.nl!',
    }
  },
}
</script>
